<template>
  <TvaModal :show="show" @onClose="$emit('onClose')">
    <article class="interview-modal">
      <InterviewSideBar
        :cardSubscript="cardSubscript"
        :cardContent="cardContent"
        :imagePath="imagePath"
        :interviewGradient="interviewGradient"
        :smallscreen="smallscreen"
        :internalUrlParam="internalUrlParam"
        @onNavigate="$emit('onNavigate')"
      />
      <InterviewContent :title="title" :content="content" :smallscreen="smallscreen" />
    </article>
  </TvaModal>
</template>

<script setup>
import { computed } from "vue";
import useTvaMq from "@/plugins/tvaMq.js";

import TvaModal from "./TvaModal.vue";
import InterviewSideBar from "./InterviewSideBar.vue";
import InterviewContent from "./InterviewContent.vue";

defineProps({
  show: Boolean,
  cardSubscript: String,
  cardContent: Object,
  title: String,
  content: Object,
  interviewGradient: String,
  imagePath: String,
  internalUrlParam: String
});

const { $tvaMq } = useTvaMq();
const smallscreen = computed(() => ["tablet", "mobile"].includes($tvaMq.value));
</script>

<style lang="scss" scoped>
.interview-modal {  
  width:  100vw;
  height: calc(var(--vh) * 100);
  background-color: var(--white-100);

  .desktop &, .large & {
    display: flex;
  }

  .mobile &, .tablet & {
    padding-top: toRem(52);
  }
}
</style>
